import { renderSingleSelectPills } from './character-options.js';

const getValueSet = (hiddenInput) => {
  if (!hiddenInput) return new Set();
  return new Set(
    hiddenInput.value
      .split(',')
      .map((v) => v.trim())
      .filter(Boolean)
  );
};

const getSingleValueSet = (hiddenInput) => {
  if (!hiddenInput) return new Set();
  const value = hiddenInput.value ? hiddenInput.value.trim() : '';
  return value ? new Set([value]) : new Set();
};

const getPillSummaryText = (label, set, multiple) =>
  multiple ? (set.size ? `${set.size} selected` : `Select ${label}`) : set.size ? Array.from(set)[0] : `Select ${label}`;

export const updateFormPillSummary = (group, set) => {
  if (!group) return;
  const label = group.dataset.pillLabel || 'Classes';
  const multiple = group.dataset.pillMultiple !== 'false';
  const summaryLabel = group.querySelector('.pill-summary-label');
  if (summaryLabel) summaryLabel.textContent = getPillSummaryText(label, set, multiple);
  group
    .querySelectorAll('.pill')
    .forEach((pill) => {
      const value = pill.getAttribute('data-pill-value');
      pill.classList.toggle('pill-active', value && set.has(value));
    });
};

const getPillLimit = (group) => {
  if (!group) return 0;
  const limit = Number(group.dataset.pillLimit || '0');
  return Number.isNaN(limit) ? 0 : limit;
};

const PILL_GROUP_SELECTOR =
  '[data-form-class-select], [data-form-status-select], [data-form-secondary-skills-select], [data-form-languages-select], [data-form-alignment-select], [data-form-player-select], [data-form-race-select], [data-form-location-select], [data-form-characters-select], [data-form-players-select]';

export const initFormPillGroups = (root = document) => {
  root
    .querySelectorAll(PILL_GROUP_SELECTOR)
    .forEach((group) => {
      if (group.dataset.pillsReady === 'true') return;
      const hidden = group.querySelector('input[type="hidden"]');
      if (!hidden) return;
      group.addEventListener('click', (event) => {
        const pill = event.target.closest('.pill');
        if (!pill || !group.contains(pill)) return;
        event.preventDefault();
        const value = pill.getAttribute('data-pill-value');
        if (!value) return;
        const multiple = group.dataset.pillMultiple !== 'false';
        const limit = getPillLimit(group);
        const set = multiple ? getValueSet(hidden) : getSingleValueSet(hidden);
        if (multiple) {
          if (set.has(value)) {
            set.delete(value);
          } else {
            if (limit > 0 && set.size >= limit) {
              const label = group.dataset.pillLabel || 'options';
              alert(`You can only select ${limit} ${label}.`);
              return;
            }
            set.add(value);
          }
          hidden.value = Array.from(set).join(', ');
        } else {
          set.clear();
          set.add(value);
          hidden.value = value;
          const list = group.querySelector('.pill-list');
          const toggleBtn = group.querySelector('[data-pill-toggle]');
          if (list) list.setAttribute('hidden', '');
          if (toggleBtn) toggleBtn.classList.remove('open');
        }
        updateFormPillSummary(group, set);
      });

      const toggle = group.querySelector('[data-pill-toggle]');
      if (toggle) {
        toggle.addEventListener('click', (event) => {
          event.preventDefault();
          const list = group.querySelector('.pill-list');
          if (!list) return;
          const isOpen = !list.hasAttribute('hidden');
          if (isOpen) {
            list.setAttribute('hidden', '');
            toggle.classList.remove('open');
          } else {
            list.removeAttribute('hidden');
            toggle.classList.add('open');
          }
        });
      }

      const form = group.closest('form');
      if (form) {
        form.addEventListener('reset', () => {
          hidden.value = '';
          updateFormPillSummary(group, new Set());
        });
      }

      group.dataset.pillsReady = 'true';
      const initialSet =
        group.dataset.pillMultiple !== 'false' ? getValueSet(hidden) : getSingleValueSet(hidden);
      updateFormPillSummary(group, initialSet);
    });
};

export const renderSingleSelectPillGroup = (group, options) => {
  if (!group) return;
  const hidden = group.querySelector('input[type="hidden"]');
  const list = group.querySelector('.pill-list');
  if (!hidden || !list) return;
  list.innerHTML = renderSingleSelectPills(options, hidden.value);
  updateFormPillSummary(group, getSingleValueSet(hidden));
};
